import { WebsailLoader } from "./loader";

// Clear storage left by the retired standalone page. Only cart choices persist.
try {
  localStorage.removeItem("ws-debug");
  localStorage.removeItem("ws-debug-test");
  localStorage.removeItem("ws-standalone-debug-retired");
} catch {
  // Browser storage is optional for loading an embedded booking form.
}

if (!window.wsintegration) {
  window.wsintegration = WebsailLoader;
  window.websail = new WebsailLoader({ loader: true });
}

export default {};
